<template>
	<valuation-layout>
		<valuation-model-stepper slot="stepper"  :current-step="2"/>
		<div slot="content">
			<weighing-factor-status
				:selected-factor="selectedFactor"
				:selected-factors="getFactorsToCompare"
				:has-next-factor="hasNext"
				:combinations="combinations"
				:factor-weighing-is-completed="evaluationFactorIsCompleted"
				:compare-pivot-index="comparePivotIndex"
				class="tw-mb-6"
				@nextFactorClick="onNextFactorClicked"
			/>
			<weighing-form
				:selected-factor="selectedFactor"
				:selected-factors="selectedFactors"
				:combinations="combinations"
				:factors-to-compare="selectedFactorFactorsToCompare"
				:enabled-countdown="!evaluationFactorIsCompleted"
				@comparePivotIndexChange="comparePivotIndex = $event"
			></weighing-form>
		</div>
		<factors-weighting-description-navigation
			slot="description"
			:selected-factors="selectedFactors"
			:combinations="combinations"
		/>
	</valuation-layout>
</template>

<script>
import ValuationLayout from '@/modules/job-evaluation/components/supplies/valuation-model/commons/ValuationLayout';
import ValuationModelStepper
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/ValuationModelStepper';
import FactorsWeightingDescriptionNavigation
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/FactosWeightingDescriptionNavigation';
import WeighingFactorStatus
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingFactorStatus';
import { mapState } from 'vuex';
import { filter, isNil, pathOr, prop, length } from 'ramda';
import WeighingForm
	from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/factors-weighting/WeighingForm';
import {
	factorWeighingIsCompleted, getFactorsToCompare,
} from '@/modules/job-evaluation/utils/valuation-model/factors';

export default {
	name: 'FactorsWeightingPage',
	components: {
		WeighingForm,
		WeighingFactorStatus,
		FactorsWeightingDescriptionNavigation,
		ValuationModelStepper,
		ValuationLayout,
	},
	data() {
		return {
			selectedFactorIndex: -1,
			selectedFactorFactorsToCompare: [],
			comparePivotIndex: 0,
		};
	},
	computed: {
		...mapState('jobEvaluation', {
			selectedFactors: pathOr([], ['supplies', 'valuationModel', 'selectedFactors']),
			selectedFactor: pathOr({}, ['supplies', 'valuationModel', 'weighing', 'selectedFactor']),
			combinations: pathOr([], ['supplies', 'valuationModel', 'weighing', 'combinations']),
		}),
		hasNext() {
			return !isNil(prop(this.selectedFactorIndex + 1, this.getFactorsToCompare));
		},
		factorWeighingIsCompleted() {
			return factorWeighingIsCompleted(this.selectedFactor, this.combinations);
		},
		evaluationFactorIsCompleted() {
			return this.selectedFactor.weighWith.length === this.comparePivotIndex + 1;
		},
		getFactorsToCompare() {
			return filter(factor => length(prop('weighWith', factor)) > 0, this.selectedFactors);
		},
	},
	beforeMount() {
		if (this.selectedFactors.length < 1) {
			this.goTo('job-supply-valuation-model-factors-choice');
		}
	},
	watch: {
		selectedFactors: {
			handler(value) {
				if (value.length > 0 && this.selectedFactorIndex < 1) {
					this.updateSelectedFactor(0);
				}
			},
			immediate: true,
		},
	},
	methods: {
		updateSelectedFactor(index) {
			this.selectedFactorIndex = index;
			this.$store.dispatch('jobEvaluation/updateSelectedFactor', prop(this.selectedFactorIndex, this.selectedFactors));
			this.selectedFactorFactorsToCompare = getFactorsToCompare(
				this.selectedFactor,
				this.combinations,
				this.selectedFactors,
			);
		},
		onNextFactorClicked() {
			this.updateSelectedFactor(this.selectedFactorIndex + 1);
		},
	},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/supplies/valuation-model/step-pages/FactorsWeightingPage.vue